import React, { Children } from 'react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { BetGliderCtaRace } from 'src/ui/assets/icons/other/BetGliderCtaRace';
import {
    ChildrenRow,
    EventBoxHeader,
    EventBoxHeaderWrapper,
    StreamIco,
    StreamSecondaryIco,
    TableSportsRowHrEventBox,
} from 'src/ui/components/table/sports/row/hr-gr/event/TableSportsRowHrEvent.style';
import { observer } from 'src/utils/mobx-react';

interface TableSportsRowHrEventPropsType {
    children?: React.ReactNode;
    className?: string;
    hasStream: boolean;
    label: JSX.Element | string;
    showBetGliderLabel?: boolean;
}

/**
 * This component will be used for sections:
 * - **AZ for HR and GR**
 * - **Build a Race card for HR and GR**
 */
export const TableSportsRowHrEvent = observer(
    'TableSportsRowHrEvent',
    ({
        className,
        children,
        hasStream,
        label,
        showBetGliderLabel = false,
    }: TableSportsRowHrEventPropsType): JSX.Element => {
        const hasChildren = Children.count(children) > 0;
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;
        const { sportsbookVariant } = configState.componentVariants;
        const { unifiedSportEventsTable } = configState;

        return (
            <TableSportsRowHrEventBox
                className={className}
                variant={sportsbookVariant}
            >
                <EventBoxHeaderWrapper variant={sportsbookVariant}>
                    <EventBoxHeader>{label}</EventBoxHeader>
                    {showBetGliderLabel ? <BetGliderCtaRace /> : null}
                    {hasStream ? unifiedSportEventsTable ? <StreamSecondaryIco /> : <StreamIco /> : null}
                </EventBoxHeaderWrapper>

                {hasChildren ? <ChildrenRow variant={sportsbookVariant}>{children}</ChildrenRow> : null}
            </TableSportsRowHrEventBox>
        );
    }
);
